/* Rastreo V1 Fase 3B para el tema GT. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  const VERSION = 'SHOPIFY_GOOGLE_V1_FASE3B_20261001';
  const SHOPIFY_REF = 'GRSGTV1S';
  const GOOGLE_PREFIX = 'GRSGTV1G';
  const SESSION_KEY = 'grs_gt_google_arrival_v1';
  const SESSION_MAX_AGE_MS = 30 * 60 * 1000;
  const GOOGLE_CAMPAIGNS = Object.freeze([
    '24128891461', // ruta V1 anterior; campaña detenida al corte Fase 3
    '24197126581', '24200651026', '24200654044',
    '24196424069', '24190549658'
  ]);
  // Selectores leídos en el tema actual; se filtra además el teléfono comercial.
  const SELECTORS = 'a#social_ws,a.social-link[title="whatsapp"],a.product-card__add.button-whtgreen,a.btn.btn--green.btn--full';
  const GOOGLE_ROUTE = Object.freeze({utm_source:'adwords',utm_medium:'ppc',hsa_acc:'1058567543'});

  function campaign(search) {
    const params = new URLSearchParams(search);
    if (!Object.entries(GOOGLE_ROUTE).every(([key,value]) =>
      params.getAll(key).length === 1 && params.get(key) === value)) return null;
    const ids = params.getAll('utm_id');
    if (ids.length !== 1 || !GOOGLE_CAMPAIGNS.includes(ids[0])) return null;
    return ids[0];
  }

  function reference(search, storedCampaign) {
    const id = campaign(search) ||
      (GOOGLE_CAMPAIGNS.includes(storedCampaign) ? storedCampaign : null);
    return id ? GOOGLE_PREFIX + id : SHOPIFY_REF;
  }

  function whatsapp(href) {
    try {
      const u = new URL(href);
      if (u.protocol !== 'https:' || u.username || u.password || u.searchParams.getAll('text').length > 1) return null;
      if (u.hostname === 'wa.me' && /^\/\+?50235654141\/?$/.test(u.pathname)) return u;
      if (['api.whatsapp.com','web.whatsapp.com'].includes(u.hostname) && /^\/send\/?$/.test(u.pathname) &&
          u.searchParams.getAll('phone').length === 1 &&
          (u.searchParams.get('phone') || '').replace(/\D/g,'') === '50235654141') return u;
    } catch (_) {}
    return null;
  }

  function destination(href, search, storedCampaign) {
    const u = whatsapp(href);
    if (!u) return href;
    // Sustituir solo el sufijo propio; conservar el contexto del producto.
    let original = (u.searchParams.get('text') || '').replace(/(?:\r?\n)?Ref: (?:GRSGTV1S|GRSGTV1G\d+)$/,'');
    // Solo la introducción exacta de las tarjetas; nombre, capacidad y modelo permanecen.
    // Evita las palabras del disparador ORG en el prellenado. Su efecto público requiere aprobación.
    original = original.replace(/^Hola, me gustaría solicitar información sobre el producto\s+/u, 'Consulta sobre el producto: ');
    u.searchParams.set('text', original + (original ? '\n' : '') + 'Ref: ' + reference(search, storedCampaign));
    return u.href;
  }

  function sessionCampaign(w, now) {
    const current = campaign(w.location.search);
    let prior = null;
    if (current) {
      try { w.sessionStorage.setItem(SESSION_KEY, JSON.stringify({id:current,at:now})); }
      catch (_) { /* La pagina actual conserva la atribucion aunque falle storage. */ }
      return current;
    }
    try {
      // Una nueva llegada directa/externa sin parametros inicia otro recorrido.
      const from = w.document.referrer && new URL(w.document.referrer);
      if (!from || from.origin !== w.location.origin) {
        w.sessionStorage.removeItem(SESSION_KEY);
        return null;
      }
      prior = JSON.parse(w.sessionStorage.getItem(SESSION_KEY) || 'null');
      if (prior && GOOGLE_CAMPAIGNS.includes(prior.id) &&
          Number.isFinite(prior.at) && now >= prior.at &&
          now - prior.at <= SESSION_MAX_AGE_MS) return prior.id;
      w.sessionStorage.removeItem(SESSION_KEY);
    } catch (_) { /* Si storage falla, no se atribuye Google por memoria. */ }
    return null;
  }

  function install(w) {
    if (!w || w.__grsRastreoV1Installed || w.location.origin !== 'https://gt.grsenlinea.com') return;
    const script = w.document.currentScript;
    if (!script || script.dataset.enabled !== 'true') return;
    w.__grsRastreoV1Installed = true;
    const storedCampaign = sessionCampaign(w, Date.now());
    function prepare(anchor) {
      if (!anchor) return;
      try {
        const before = anchor.getAttribute('href');
        const after = destination(before, w.location.search, storedCampaign);
        if (after !== before) anchor.setAttribute('href',after);
      } catch (_) { /* Un fallo conserva el enlace existente. */ }
    }
    function refresh() { w.document.querySelectorAll(SELECTORS).forEach(prepare); }
    if (w.document.readyState === 'loading') w.document.addEventListener('DOMContentLoaded',refresh,{once:true});
    else refresh();
    // El clic y la navegacion conservan la senal solo durante esta sesion acotada.
    function onGesture(event) { prepare(event.target.closest && event.target.closest(SELECTORS)); }
    ['pointerdown','click','auxclick','contextmenu'].forEach(type => w.document.addEventListener(type,onGesture,true));
    w.addEventListener('popstate',refresh);
  }
  return {VERSION,SHOPIFY_REF,GOOGLE_PREFIX,GOOGLE_CAMPAIGNS,GOOGLE_ROUTE,
    SELECTORS,SESSION_KEY,SESSION_MAX_AGE_MS,campaign,reference,whatsapp,
    destination,sessionCampaign,install};
});
